export enum URL {
  gift_card_form_nonce = 'gift-cards/from-nonce',
  service_items = 'service-items',
  current_orders = '',
  process = 'compress/?'
}
